import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  Checkbox // , Button, Dropdown
} from 'semantic-ui-react';
import PanelLayout from '../panel/layout';
import Const from '../../config/const';
import * as shared from '../assets/shared.module.scss';
import * as classes from './classes.module.scss';

export default class GuidesConfig extends PureComponent {
  static propTypes = {
    rulerVisible: PropTypes.bool.isRequired,
    guidesVisible: PropTypes.bool.isRequired,
    widthVisible: PropTypes.bool.isRequired,
    heightVisible: PropTypes.bool.isRequired,

    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,

    closePanel: PropTypes.func.isRequired,

    showRuler: PropTypes.func.isRequired,
    hideRuler: PropTypes.func.isRequired,

    showGuides: PropTypes.func.isRequired,
    hideGuides: PropTypes.func.isRequired,

    showWidth: PropTypes.func.isRequired,
    hideWidth: PropTypes.func.isRequired,
    setWidth: PropTypes.func.isRequired,

    showHeight: PropTypes.func.isRequired,
    hideHeight: PropTypes.func.isRequired,
    setHeight: PropTypes.func.isRequired
  };

  closePanel = () => {
    const { closePanel } = this.props;
    closePanel(Const.panelKinds.grids);
  };

  onShowGrid = (e, { checked }) => {
    const { showRuler, hideRuler } = this.props;
    (checked ? showRuler : hideRuler)();
  };

  onShowGuides = (e, { checked }) => {
    const { showGuides, hideGuides } = this.props;
    (checked ? showGuides : hideGuides)();
  };

  // onShowWidth = (e, { checked }) => {
  //   const { showWidth, hideWidth } = this.props;
  //   (checked ? showWidth : hideWidth)();
  // };

  // onShowHeight = (e, { checked }) => {
  //   const { showHeight, hideHeight } = this.props;
  //   (checked ? showHeight : hideHeight)();
  // };

  // onWidthChanged = (e) => {
  //   const { setWidth } = this.props;
  //   setWidth(parseFloat(e.target.value));
  // };

  // onHeightChanged = (e) => {
  //   const { setHeight } = this.props;
  //   setHeight(parseFloat(e.target.value));
  // };

  render() {
    const {
      rulerVisible, guidesVisible // , widthVisible, heightVisible, width, height
    } = this.props;
    return (
      <PanelLayout onClose={ this.closePanel } title="Rulers and Grid">
        <div className={ classes.container }>
          <p>
            Better understand the measurement of your art grouping - measurements are in inches.
          </p>
          <h4 className={ shared.h4 }>
            View
          </h4>
          <div>
            <Checkbox
              checked={ !!rulerVisible }
              label="Show Rulers"
              onChange={ this.onShowGrid }
              className={ classes.checkbox }
            />
            <Checkbox
              checked={ !!guidesVisible }
              label="Show Grid"
              onChange={ this.onShowGuides }
              className={ classes.checkbox }
            />
            <p>&nbsp;</p>
          </div>
        </div>
      </PanelLayout>
    );
  }
}

/*

          <h4 className={ shared.h4 }>
            Wall Size
          </h4>
          <div className={ classes.line }>
            <Checkbox
              checked={ !!widthVisible }
              label="Show Width"
              onChange={ this.onShowWidth }
              className={ classes.checkbox }
            />
            <input type="number" min="40" value={ width } onChange={ this.onWidthChanged } />
          </div>
          <div className={ classes.line }>
            <Checkbox
              checked={ !!heightVisible }
              label="Show Height"
              onChange={ this.onShowHeight }
              className={ classes.checkbox }
            />
            <input type="number" min="40" value={ height } onChange={ this.onHeightChanged } />
          </div>
*/
